import { IOProps } from 'react-compose-io'
import { RegraNotaFiscalIO } from './RegraNotaFiscal.IO'
import { RegraNotaFiscalForm } from './components/RegraTransformacaoForm'

export type RegraNotaFiscalProps = {}

export function RegraNotaFiscalView({ _io }: IOProps<RegraNotaFiscalIO, RegraNotaFiscalProps>) {
  function RegraNotaFiscalEdicao() {
    return <>{_io.regraNotaFiscalEditar ? <RegraNotaFiscalForm regraNotaFiscalEditar={_io.regraNotaFiscalEditar} /> : null}</>
  }

  return _io.regraId ? RegraNotaFiscalEdicao() : <RegraNotaFiscalForm />
}
